import { differenceInCalendarDays } from "date-fns";
import { createLocalDate, formatTimeAgo } from "@/utils/dateUtils";

export {
  createLocalDate,
  formatDateBR,
  formatDateTime,
  formatDateOnly,
  formatUtcDate,
  formatLocalDate,
  formatTimeAgo,
} from "@/utils/dateUtils";

/** Aceita data lógica ("YYYY-MM-DD") ou instante ISO. */
function toDate(value: string | Date): Date {
  return value instanceof Date ? value : createLocalDate(value);
}

/** Dias de calendário até a data (negativo = já passou). */
export function daysUntil(value: string | Date, today: Date = new Date()): number {
  return differenceInCalendarDays(toDate(value), today);
}

/**
 * Tempo relativo nos dois sentidos: "hoje", "amanhã", "em 3 dias", "há 2 dias".
 * Para o passado distante reaproveita formatTimeAgo ("há 3 meses").
 */
export function formatRelative(value: string | Date, today: Date = new Date()): string {
  const days = daysUntil(value, today);
  if (days === 0) return "hoje";
  if (days === 1) return "amanhã";
  if (days === -1) return "ontem";
  if (days > 1) return days < 30 ? `em ${days} dias` : `em ${Math.round(days / 30)} ${Math.round(days / 30) === 1 ? "mês" : "meses"}`;
  return formatTimeAgo(toDate(value)).text;
}

export type DueState = "overdue" | "today" | "soon" | "ok";

export interface DueInfo {
  state: DueState;
  days: number;
  label: string;
}

/**
 * Regra única de prazo. `warnAt` é quantos dias antes vira "perto" (vagas usam
 * 7, projetos 10); o limite fica no domínio, a regra não.
 */
export function dueInfo(value: string | Date, { warnAt = 7, today = new Date() }: { warnAt?: number; today?: Date } = {}): DueInfo {
  const days = daysUntil(value, today);
  if (days < 0) {
    const late = -days;
    return { state: "overdue", days, label: `Vencido há ${late} ${late === 1 ? "dia" : "dias"}` };
  }
  if (days === 0) return { state: "today", days, label: "Vence hoje" };
  if (days <= warnAt) return { state: "soon", days, label: `Vence em ${days} ${days === 1 ? "dia" : "dias"}` };
  return { state: "ok", days, label: `${days} dias` };
}
